import type { IconType } from 'react-icons';
import { MdOutlinePower } from 'react-icons/md';

import type { ShoreConnectionKey, YNValue } from '../types';

import { SectionHeader } from './SectionHeader';
import s from './ShoreConnectionsSection.module.scss';
import { YNToggle } from './YNToggle';

interface ShoreConnectionsSectionProps {
  values: Record<ShoreConnectionKey, YNValue>;
  onChange: (key: ShoreConnectionKey, val: YNValue) => void;
  icon?: IconType;
}

const CONNECTIONS: Array<{ key: ShoreConnectionKey; label: string }> = [
  { key: 'power', label: 'Shore Power' },
  { key: 'water', label: 'Water' },
  { key: 'phone', label: 'Phone' },
  { key: 'internet', label: 'Internet' },
];

export function ShoreConnectionsSection({
  values,
  onChange,
  icon: Icon = MdOutlinePower,
}: ShoreConnectionsSectionProps) {
  return (
    <div className={s.section}>
      <SectionHeader icon={Icon} title="Shore Connections" />

      <div className={s.rows}>
        {CONNECTIONS.map(({ key, label }) => (
          <div key={key} className={s.row}>
            <span className={s.label}>{label}</span>
            <YNToggle value={values[key]} onToggle={(val) => onChange(key, val)} />
          </div>
        ))}
      </div>
    </div>
  );
}
